<template>
  <section class="home" :class="$bus.rotating ? 'prevent': ''">
    <Loading/>
    <Toast :show="$bus.toast.show"/>
    <section class="main">
      <ff-header/>
      <div class="inner">
        <ff-main class="home-main" />
        <Pool class="home-pool"/>
      </div>
    </section>
    <Confirm/>
    <Buy/>
    <Rule/>
    <History/>
    <Products />
    <Discount/>
    <Share/>
    <AlertDialog :show.sync="$bus.alertShow" :title="$bus.alertTitle" :content="$bus.alertContent" />
  </section>
</template>
<script>
import { setSessionStorage, getSessionStorage, initGA, addGA, errorGA, unityPromise } from '@/utils/assist'
import Toast from '@/components/common/Toast.vue'
import Loading from '@/components/common/Loading.vue'
import ffHeader from '@/components/common/Header.vue'
import Pool from '@/components/pool/'
import ffMain from '@/components/main/'
import Confirm from '@/components/confirm/'
import Rule from '@/components/rule/'
import History from '@/components/history/'
import Products from '@/components/products'
import Buy from '@/components/buy/'
import Discount from '@/components/discount/'
import Share from '@/components/share/'
import {Howler} from 'howler'
import sound from '@/mixins/sound'
import AlertDialog from '@/components/alert'

export default {
  mixins: [sound],
  name: 'home',
  components: {
    Loading,
    Toast,
    ffHeader,
    Pool,
    ffMain,
    Confirm,
    Rule,
    History,
    Buy,
    Discount,
    Share,
    Products,
    AlertDialog
  },
  methods: {
    initInfo () {
      let accessToken = getSessionStorage(`${PROJECT_NAME}AccessToken`) || ''
      let lang = getSessionStorage(`${PROJECT_NAME}Lang`) || ''
      let region = getSessionStorage(`${PROJECT_NAME}Region`) || ''
      if (!accessToken) return this.$bus.handleError('TOAST_LOGIN_FAILED')
      this.$api
        .info({
          access_token: accessToken,
          lang,
          region
        })
        .then(response => {
          let data = response.data
          const { uid, gems, transify, lang, region, stats, config, event, policy_popup } = data

          // 新增
          this.$bus.productsDialog.data = event.pool
          // 初始化数据
          this.$bus.uid = uid
          this.$bus.gems = gems
          this.$bus.transify = transify
          this.$bus.rule.content = config.rules
          this.$bus.refreshFreeTimes = stats.refresh_free_times
          this.$bus.refreshCost = config.refresh_cost
          this.$bus.finish = stats.finish
          this.$bus.canRefresh = stats.can_refresh

          if (policy_popup) {
            const { popup_title: policyTitle, popup_content: policyCtx, checked: policyHide } = policy_popup
            this.$bus.alertShow = !policyHide
            this.$bus.alertTitle = policyTitle
            this.$bus.alertContent = policyCtx
          }

          // 音效
          unityPromise('Volume', 'music').then(res => {
            // this.$bus.currentVolume = res
            if (res == 0) {
              this.$bus.bgmStatus = false
            } else {
              // 非静音状态
              if (
                localStorage.getItem(`${PROJECT_NAME}_${this.$bus.uid}_bgm`) === 'n'
              ) {
                this.$bus.bgmStatus = false           
              } else {
                this.$bus.bgmStatus = true
                Howler.volume(res)
              }
            }
          }).catch(() => {
            if (
              localStorage.getItem(`${PROJECT_NAME}_${this.$bus.uid}_bgm`) === 'n'
            ) {
              this.$bus.bgmStatus = false    
            } else {
              this.$bus.bgmStatus = true
            }
          })

          // 折扣列表
          // 如果存在抽中但未使用的情况
          this.$bus.enable = stats.enable
          this.$bus.originDiscountPool = event.discount_list
          this.$bus.discountPool = this.$bus.formatDiscountList(event.discount_list.slice(), stats.disable, this.$bus.enable)
          // 如果有未使用的折扣
          if (this.$bus.enable !== -1) {
            const index = this.$bus.discountPool.findIndex(item => item.pk === this.$bus.enable)
            this.$bus.prevRotateIndex = index
            this.$bus.deltaAngle = (9 - index) * 45
          } else if (stats.disable.length < 8 && stats.disable.length > 0) {
            this.$bus.deltaAngle = 67
          } else {
            // 初始状态
            this.$bus.deltaAngle = 45
          }

          // 当前奖池
          this.$bus.purchased = stats.purchased
          this.$bus.rewardPool = this.$bus.formatRewardPool(event.pool.slice(), stats.pool, stats.purchased)

          this.initNotice()
          // GA
          document.body.setAttribute('data-lang', lang)
          initGA(region, uid)
        })
    },
    initNotice () {
      let refreshNotice = localStorage.getItem(`${PROJECT_NAME}_refresh_${this.$bus.uid}`)
      this.$bus.refreshNotice = refreshNotice !== 'false'
    },
    bindDocumentTouchend () {
      document.addEventListener('touchend', () => {
        this.$bus.activeIndex = -1
      })

      document.addEventListener('click', () => {
        this.$bus.activeIndex = -1
      })
    },
    forbidScale () {
      let lastTouchEnd = 0
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('touchend', function (event) {
        const now = (new Date()).getTime()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      }, false)
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
  },
  mounted () {
    this.initInfo()
    this.bindDocumentTouchend()
    this.forbidScale()
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-position-y: top;
  .main {
    width: 100%;
    height: 100%;
    @include flexcc;
  }
  &.prevent {
    pointer-events: none;
  }
}
.inner {
  @include flexrc;
  @include px2res(padding, 0, 20);
  justify-content: space-around;
  position: relative;
  width: 100%;
  height: 100%;

}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue